import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { translate as t } from '../../lib/I18n';


function Loading({ className, standalone, unwrapped, inline, message, children }) {
    const loader = (
        <div className={ classnames('loading', className, {
                 'loading--standalone': standalone,
                 'text-center': !inline,
                 'loading--inline': inline
             }) }>
            <span className="otrl circle-spinner" />
            { message && <p className="loading-message">{ t(message) }</p> }
            { children }
        </div>
    );
    return unwrapped || inline ? loader : <div className="left-col left-col--loading">{ loader }</div>;
}


Loading.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string,
    unwrapped: PropTypes.bool,
    standalone: PropTypes.bool,
    inline: PropTypes.bool,
    children: PropTypes.any
};

Loading.defaultProps = {
    className: '',
    unwrapped: false,
    standalone: false,
    inline: false,
    children: null
};


export default Loading;
